<template>
  <v-row>
    <v-col>
      <h1 class="text-h3">{{ t('common.applicationsAndDasboards') }}</h1>
    </v-col>
  </v-row>
  <v-row class="mt-10">
    <v-col>
      <h2 class="text-h5">{{ t('common.applications') }}</h2>
    </v-col>
    <v-col class="text-right">
      <v-btn variant="text" color="primary">{{ t('common.viewAllButton') }}</v-btn>
    </v-col>
  </v-row>
  <AppList />
  <v-row v-if="canReadDashboards" class="mt-10">
    <v-col>
      <h2 class="text-h5">{{ t('common.dashboards') }}</h2>
    </v-col>
    <v-col class="text-right">
      <v-btn variant="text" color="primary">{{ t('common.viewAllButton') }}</v-btn>
    </v-col>
  </v-row>
  <v-row v-if="canReadDashboards">
    <v-col v-for="dashboard in dashboards" :key="dashboard.id">
      <DashboardCard
        :title="dashboard.title"
        :description="dashboard.description"
        :icon="dashboard.icon"
        :link="dashboard.link"
        :color="dashboard.color"
        :type="dashboard.type"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import AppList from '@/components/AppList.vue'
import DashboardCard from '@/components/DashboardCard.vue'
import { daisukeStore } from '@tsyl/daisuke-auth-plugin'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const daisuke = daisukeStore()

const dashboards = [
  {
    id: 1,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
  {
    id: 2,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
  {
    id: 3,
    title: 'Dashboard Name',
    description: 'Description goes here.',
    icon: 'mdi-directions',
    link: '#',
    color: 'secondary',
    type: 'TYPE',
  },
]
const canReadDashboards = daisuke.hasPermission('read:dashboards')
</script>
